import { Col, Row } from 'react-grid-system'
import styled from 'styled-components'
import { ImageUploader, NormalFormTextArea, VideoUploader } from '../molecules'
import { useCreateIncidentContext, useUserLanguage } from '@/customHooks'
import textsData from '@/textData/CreateIncidentTexts.json'
import { useCallback, useEffect, useState } from 'react'

const TEXT_LIMIT = 2000

const FieldContainer = styled.div`
  background-color: white;
  border-radius: ${({ theme }) => theme.border.radius.lg};
  padding: 2rem;
  margin-bottom: 3rem;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  min-width: 360px;
  width: 550px;
`

const TextWarnContainer = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.s6};
  padding-left: 1rem;
`

export const SelectIncidentEvidenceForm = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.incidentEvidence : textsData.en.incidentEvidence

  const { state, setNote, setButtonEnabled, setButtonDisabled, setPictures, setVideos } = useCreateIncidentContext()

  const [availableChars, setAvailableChars] = useState(TEXT_LIMIT - (state.incidentNote?.length || 0))

  useEffect(() => {
    if (state.incidentNote && state.incidentNote.length > 0) {
      setButtonEnabled()
    } else {
      setButtonDisabled()
    }
  }, [state.incidentNote, setButtonEnabled, setButtonDisabled])

  const onChangeHandle = useCallback((text: string | null) => {
    const noteText = text || ''
    setNote(noteText)

    if (noteText.length === 0) {
      setButtonDisabled()
    } else {
      setButtonEnabled()
    }

    setAvailableChars(TEXT_LIMIT - noteText.length)
  }, [setNote, setButtonEnabled, setButtonDisabled])

  const onPicturesReadyHandle = (pictures: File[]) => {
    setPictures(pictures)
  }

  const onVideosReadyHandle = (videos: File[]) => {
    setVideos(videos)
  }

  return (
    <Row justify="center">
      <Col xs="content">
        <FieldContainer>
          <NormalFormTextArea
            label={texts.textFieldName}
            name="note"
            value={state.incidentNote}
            onChange={onChangeHandle}
          />
          <TextWarnContainer>
            <p>{`${availableChars} ${texts.availableChars}`}</p>
          </TextWarnContainer >
          <ImageUploader onUploadReady={onPicturesReadyHandle}/>
          <VideoUploader onUploadReady={onVideosReadyHandle}/>
        </FieldContainer>
      </Col>
    </Row>
  )
}